import { render, staticRenderFns } from "./ChatBoxFooter.vue?vue&type=template&id=0ae43de7&scoped=true&"
import script from "./ChatBoxFooter.vue?vue&type=script&lang=js&"
export * from "./ChatBoxFooter.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxFooter.vue?vue&type=style&index=0&id=0ae43de7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae43de7",
  null
  
)

export default component.exports